import type { ApiTmpStorageId } from '#/api/types/ApiTypedId';
import { FetchEndpoint } from '#/utils/endpoint/FetchEndpoint';

import type { ListingApiTmpStorage } from './types/ListingApiTmpStorage';

type ApiResponse = {
  data: string;
};

function mapResponse(response: ApiResponse) {
  const parsedData = JSON.parse(
    response.data,
  ) as unknown as ListingApiTmpStorage | null;

  if (
    parsedData?.type !== 'listing-application' &&
    parsedData?.type !== 'mark-as-applied'
  )
    return null;

  return parsedData;
}

const endpoint = new FetchEndpoint({
  urlFactory: (tmpStorageId: ApiTmpStorageId) =>
    `/data/tmp-storage/${tmpStorageId}`,
  mapResponse,
});

// Exports

export const listingApiClientFetchTmpStorage = endpoint.client();
